export * as BookingsServiceForm from './dashboard-page-plugins/db6319e8-f8d6-4de3-830e-917d4e5c6d47.js';
export * as BookingCalendar from './dashboard-page-plugins/bbbc8c7d-19b9-4a86-bfc5-1bf59208b01b.js';
export * as BookingList from './dashboard-page-plugins/3b9b5f2b-adc9-4099-80e6-5e74bc30e613.js';
export * as Services from './dashboard-page-plugins/c756378f-3438-41c6-a686-85e9fb0193ac.js';
export * as BookingsStaffMemberForm from './dashboard-page-plugins/a6a6a0ee-865f-43cc-a8f2-b50984f74457.js';
export * as BookingsPolicyForm from './dashboard-page-plugins/9728c715-8b64-4d9b-b5a6-a33c201ce8e6.js';
export * as Staff from './dashboard-page-plugins/a4f36fac-ea18-483b-8236-095e29fcb726.js';
